import { cn } from "@/lib/utils";
import { FieldProps } from "formik";
import { RequiredIndicator } from "@/components/Common/RequiredIndicator/RequiredIndicator";

interface BaseFieldLayoutProps<T> extends FieldProps {
  label?: React.ReactNode;
  required?: boolean;
  inputComponent: React.ComponentType<T>;
  hideError?: boolean;
  baseHOCClassName?: string;
}

const BaseFieldLayout = (
  props: BaseFieldLayoutProps<{
    onChange: (value: unknown) => void;
    error?: boolean;
    baseHOCClassName?: string;
  }>
) => {
  const { label, required, inputComponent: InputComponent, hideError, form, field, ...rest } =
    props;

  const error =
    !hideError && form.errors[field.name] && form.touched[field.name]
      ? form.errors[field.name]
      : "";
  const errorText = Array.isArray(error) ? error.join(", ") : error;

  return (
    <div className={cn("relative flex flex-1 flex-col pb-5", props.baseHOCClassName)}>
      {label ? (
        <label className="subtext-small mb-2 text-gray-dark-2200 dark:text-gray-dark-1000">
          {label}
          {required ? (
            <>
              {" "}
              <RequiredIndicator />
            </>
          ) : null}{" "}
          {error && (
            <span className="subtext-x-small ml-2 rounded-md bg-red-dark-300 bg-opacity-20 px-2 py-1 text-red-dark-300">
              {errorText as string}
            </span>
          )}
        </label>
      ) : null}
      <InputComponent
        {...rest}
        {...field}
        error={!!error}
        onChange={(value: unknown) => {
          form.setFieldTouched(field.name, true, true);
          form.setFieldValue(field.name, value, true);
        }}
      />
    </div>
  );
};

export default BaseFieldLayout;
